import React from "react";
import PropTypes from "prop-types";
import "../../common/CommonText.css";
import "./ExitPageWarningPopup.css";
import { useTranslation } from "react-i18next";

const ExitPageWarningPopup = ({ isOpen, onSave, onClose }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="discard-popup popup archive-popup popup2">
        <div className="discard-heading">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
          >
            <path
              d="M16.5 1.375C9.50945 1.375 1.48633 3.09375 1.48633 16.5C1.48633 29.9062 9.50945 31.625 16.5 31.625C23.4905 31.625 31.5136 29.9062 31.5136 16.5C31.5136 3.09375 23.4905 1.375 16.5 1.375ZM15.125 9.38163C15.125 8.62125 15.7396 8.00663 16.5 8.00663C17.2603 8.00663 17.875 8.62125 17.875 9.38163V17.1724C17.875 17.9328 17.2603 18.5474 16.5 18.5474C15.7396 18.5474 15.125 17.9328 15.125 17.1724V9.38163ZM16.5 24.7968C15.3642 24.7968 14.443 23.8755 14.443 22.7397C14.443 21.604 15.3642 20.6828 16.5 20.6828C17.6357 20.6828 18.557 21.604 18.557 22.7397C18.557 23.8755 17.6357 24.7968 16.5 24.7968Z"
              fill="url(#paint0_linear_16479_5952)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_16479_5952"
                x1="16.5"
                y1="1.375"
                x2="16.5"
                y2="31.625"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFAB00" />
                <stop offset="1" stop-color="#D48E00" />
              </linearGradient>
            </defs>
          </svg>
          <h6 className="confirm-archive common-text ftw-4">
            {t("Wait a second!")}
          </h6>
        </div>

        <div className="discard-content">
          <p className="card-title lt-gray discard-popup-content">
            {t(
              "You have unsaved changes. If you leave now, your changes will be lost.",
            )}
          </p>
        </div>

        <div className="discard-popup-buttons">
          <button className="stay-button" onClick={onClose}>
            {t("Stay on page")}
          </button>
          <button className="discard-button" onClick={onSave}>
            {t("Leave & Discard Changes")}
          </button>
        </div>
      </div>
    </div>
  );
};

ExitPageWarningPopup.propTypes = {
  isOpen: PropTypes.bool,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

export default ExitPageWarningPopup;
